<template>
  <div id="contest-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="onSaveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onUnpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onSaveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">Add/Edit Contest</h1>
            <fieldset>
              <legend>Basic information</legend>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2"
                  >Contest Title*</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    required
                    v-model="$v.formData.title.$model"
                    :class="{
                      'is-invalid': $v.formData.title.$error,
                      'is-valid':
                        $v.formData.title.$error == false &&
                        $v.formData.title.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a title.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description*</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                    v-model="$v.formData.description.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.description.$error,
                      'is-valid':
                        $v.formData.description.$error == false &&
                        $v.formData.description.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">
                    Please enter a Description.
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="participate" class="form-label col-md-2"
                  >How to participate:</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="participate"
                    rows="4"
                    v-model="formData.rules"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="Terms" class="form-label col-md-2"
                  >Terms & Conditions:</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="Terms"
                    rows="4"
                    v-model="formData.terms"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2"
                  >Start date</label
                >
                <div class="col-md-10">
                  <DateRangeControl v-model="formData.startDate" />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">End date</label>
                <div class="col-md-10">
                  <DateRangeControl v-model="formData.endDate" />
                </div>
              </div>
              <div class="form-group row">
                <label for class="form-label col-md-2">Hashtag</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="formData.socialIdentifiers"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Image</legend>
              <div>
                <ImageUploadButton
                  newColor="var(--campaign-color)"
                  ref="imageUploader"
                  :imageUrl="
                    formData.thumbnailUrl != '' ? formData.thumbnailUrl : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Prizes</legend>
              <PrizesControl v-model="formData.prizes" ref="urls" />
            </fieldset>
            <fieldset>
              <legend>Winners</legend>
              <div class="form-group row">
                <label for="contest-type" class="form-label col-md-2"
                  >CONTEST TYPE:</label
                >
                <div class="col-md-10 pt-0 pb-0">
                  <div class="row">
                    <div class="col-md-12 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check1"
                          value="most_likes"
                          style="margin-top: 8px"
                          v-model="formData.campaignType"
                        />
                        <label class="form-check-label" for="Check1"
                          >Content with most 'Likes' wins</label
                        >
                      </div>
                    </div>
                    <div class="col-md-4 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check2"
                          value="select_by_jury"
                          style="margin-top: 8px"
                          v-model="formData.campaignType"
                        />
                        <label class="form-check-label" for="Check2"
                          >Winner is determined by a jury</label
                        >
                      </div>
                    </div>
                    <div class="col-md-3 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check3"
                          value="rank_voting"
                          v-model="formData.juryVotingType"
                          style="margin-top: 8px"
                          :disabled="formData.campaignType != 'select_by_jury'"
                        />
                        <label class="form-check-label" for="Check3"
                          >Rank voting</label
                        >
                      </div>
                    </div>
                    <div class="col-md-3 pt-0 pb-0">
                      <div class="form-group form-check">
                        <input
                          type="radio"
                          class="form-check-input"
                          id="Check4"
                          value="points_voting"
                          v-model="formData.juryVotingType"
                          style="margin-top: 8px"
                          :disabled="formData.campaignType != 'select_by_jury'"
                        />
                        <label class="form-check-label" for="Check4"
                          >Points voting</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contest-type" class="form-label col-md-2"
                  >FREQUENCY:</label
                >
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-12 pt-0 pb-0">
                      <div class="row">
                        <div class="col-md-3 pt-0 pb-0">
                          <div class="form-group form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="CheckFrequency1"
                              value="once"
                              style="margin-top: 10px"
                              v-model="formData.frequency"
                            />
                            <label
                              class="form-check-label"
                              for="CheckFrequency1"
                              >Once</label
                            >
                          </div>
                        </div>
                        <div class="col-md-3 pt-0 pb-0">
                          <div class="form-group form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="CheckFrequency2"
                              value="several_times"
                              style="margin-top: 10px"
                              v-model="formData.frequency"
                            />
                            <label
                              class="form-check-label"
                              for="CheckFrequency2"
                              >Several times</label
                            >
                          </div>
                        </div>
                        <div class="col-md-6 pt-0 pb-0">
                          <div class="row">
                            <div class="col-md-6 pt-1 pb-0">
                              Number of instances
                            </div>
                            <div class="col-md-6 pt-1 pb-0">
                              <input
                                type="number"
                                class="form-control"
                                v-model="
                                  formData.severalTimesOptions.numberOfInstances
                                "
                                :disabled="
                                  formData.frequency != 'several_times'
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 pt-0 pb-0">
                          <div class="form-group form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="CheckFrequency3"
                              value="daily"
                              style="margin-top: 10px"
                              v-model="formData.frequency"
                            />
                            <label
                              class="form-check-label"
                              for="CheckFrequency3"
                              >Daily</label
                            >
                          </div>
                        </div>
                        <div class="col-md-3 pt-0 pb-0">
                          <div class="form-group form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="CheckFrequency4"
                              value="weekly"
                              style="margin-top: 10px"
                              v-model="formData.frequency"
                            />
                            <label
                              class="form-check-label"
                              for="CheckFrequency4"
                              >Weekly</label
                            >
                          </div>
                        </div>
                        <div class="col-md-6 pt-0 pb-0">
                          <div class="form-group form-check">
                            <input
                              type="radio"
                              class="form-check-input"
                              id="CheckFrequency5"
                              value="monthly"
                              style="margin-top: 10px"
                              v-model="formData.frequency"
                            />
                            <label
                              class="form-check-label"
                              for="CheckFrequency5"
                              >Monthly</label
                            >
                          </div>
                        </div>
                        <div class="col-md-4 pt-0 pb-0">
                          Closing date of first instance
                        </div>
                        <div class="col-md-3 pt-0 pb-0">
                          <input
                            type="date"
                            ref="date"
                            class="form-control"
                            :disabled="formData.frequency != 'several_times'"
                          />
                        </div>
                        <div class="col-md-2 pt-0 pb-0 text-right">Time:</div>
                        <div class="col-md-3 pt-0 pb-0">
                          <input
                            type="time"
                            ref="time"
                            class="form-control"
                            :disabled="formData.frequency != 'several_times'"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="form-label col-md-2">VOTING:</label>
                <div class="col-md-10 pt-0">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="voting"
                          id="voting1"
                          value="submissions_open"
                          v-model="formData.votingStartWhen"
                        />
                        <label class="form-check-label" for="voting1"
                          >Voting starts when submissions open</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="voting"
                          id="voting2"
                          value="submissions_close"
                          v-model="formData.votingStartWhen"
                        />
                        <label class="form-check-label" for="voting2"
                          >Voting starts when submissions close</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-8">
                          Number of days for voting after closing of submissions
                        </div>
                        <div class="col-md-4">
                          <input
                            type="number"
                            class="form-control"
                            v-model="formData.daysVotingAfterSubmissionsClose"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contest-type" class="form-label col-md-2 pt-0 pb-0"
                  >ANNOUNCEMENT</label
                >
                <div class="col-md-10 pt-0 pb-0">
                  <div class="row">
                    <div class="col-md-8 pt-1">
                      Number of days until announcement of winner
                    </div>
                    <div class="col-md-4 pt-1">
                      <input
                        type="number"
                        class="form-control"
                        v-model="formData.daysUntilAnnounceWinners"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="contest-type" class="form-label col-md-2 pt-0 pb-0"
                  >JURY</label
                >
                <div class="col-md-10 pt-0 pb-0">
                  <div class="row">
                    <div class="col-md-12 pt-1">
                      <table style="width: 100%">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Title</th>
                            <th>Email</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Mr. Jury Member</td>
                            <td>Managing Director, Ch...</td>
                            <td>jurymember@ch...</td>
                            <td>
                              <span class="underline">Edit</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 pt-1">
                      <JuryControl />
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>PARTICIPATING EXPERIENCES</legend>
              <!-- <div class="form-group row">
                <label for="experiences" class="form-label col-md-2"
                  >Experiences</label
                >
                <div class="col-md-10">
                  <ExperiencePicker v-model="formData.experiences" />
                </div>
              </div> -->
              <div class="form-group row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio1"
                      value="private"
                      v-model="formData.experiencesParticipation.privacy"
                    />
                    <label class="form-check-label" for="inlineRadio1"
                      >This contest is not public to other experiences.</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio2"
                      value="public"
                      v-model="formData.experiencesParticipation.privacy"
                    />
                    <label class="form-check-label" for="inlineRadio2"
                      >Any experience can join the contest without
                      approval.</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="inlineRadioOptions"
                      id="inlineRadio3"
                      value="manual_approval"
                      v-model="formData.experiencesParticipation.privacy"
                    />
                    <label class="form-check-label" for="inlineRadio3"
                      >Any experience can join the contest with my
                      approval.</label
                    >
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="joining"
                      id="joining1"
                      value="1"
                    />
                    <label class="form-check-label" for="joining1"
                      >Joining experiences cannot contribute prizes</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="joining"
                      id="joining2"
                      value="2"
                    />
                    <label class="form-check-label" for="joining2"
                      >Joining experiences can contribute prizes</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="joining"
                      id="joining3"
                      value="3"
                    />
                    <label class="form-check-label" for="joining3"
                      >Joining experiences must contribute prizes</label
                    >
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-2 text-right">
                  <span>Minimum value</span>
                </div>
                <div class="col-md-5">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="0 = any value"
                  />
                </div>
                <div class="col-md-2">
                  <select name="" class="form-control">
                    <option value="USD">USD</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="Participating"
                      id="Participating1"
                      value="2"
                    />
                    <label class="form-check-label" for="Participating1"
                      >Participating experiences are able to see the
                      results</label
                    >
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="Participating"
                      id="Participating2"
                      value="3"
                    />
                    <label class="form-check-label" for="Participating2"
                      >Participating experiences are not able to see the
                      results</label
                    >
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-2">EXPERIENCES</div>
                <div class="col-md-10">
                  <table style="width: 100%">
                    <thead>
                      <tr>
                        <th>Experience Name</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Bangkok Hotel Association</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Experience Mekong Collection</td>
                        <td>Confirmed</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                      <tr>
                        <td>Thailand Hotel Association</td>
                        <td>Requested</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <AddContentButton color="#C32AA3"
                    >ADD EXPERIENCE AFFILIATION</AddContentButton
                  >
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-2">PROMOTION</div>
                <div class="col-md-10">
                  <table style="width: 100%">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th>Size</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Marketing_Flyer.jpg</td>
                        <td>1.2 MB</td>
                        <td><span class="underline">Edit</span></td>
                      </tr>
                    </tbody>
                  </table>
                  <AddContentButton color="#C32AA3"
                    >ADD PROMOTIONAL MATERIALS</AddContentButton
                  >
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Distribution</legend>
              <div class="form-group row">
                <div class="offset-md-2 col-md-10">
                  <PlatformPicker
                    v-model="formData.platforms"
                    :countries="formData.country ? [formData.country] : []"
                    color="var(--color-purple)"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="Distribution"
                      id="Distribution"
                      value="2"
                    />
                    <label class="form-check-label" for="Distribution"
                      >Only permit and distribute content after I have manually
                      approved it.</label
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      name="Distribution"
                      id="Distribution2"
                      value="3"
                    />
                    <label class="form-check-label" for="Distribution2"
                      >All content aggregated for this contest is automatically
                      approved, participating, and distributed to all
                      channels</label
                    >
                  </div>
                </div>
              </div>
            </fieldset>
            <EnwokeDeclarationFieldset
              v-model="formData.isAcceptedEnwokeAgreement"
              @delete="onDelete"
              contentName="Contest"
            />
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="onSaveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onUnpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="onSaveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import ImageUploadButton from "@/components/ImageUploadButton";
import ExperiencePicker from "@/components/ExperiencePicker";
import PrizesControl from "@/components/PrizesControl";
import JuryControl from "@/views/Contests/Components/JuryForm";
import DateRangeControl from "@/components/DateRangeControl";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import moment from "moment";
import AddContentButton from "@/components/AddContentButton";
import PlatformPicker from "@/components/PlatformPicker";
import _ from "lodash";

const defaultFormData = {
  title: "",
  description: "",
  rules: "",
  terms: "",
  startDate: "",
  endDate: "",
  socialIdentifiers: "",
  mainImageUrl: "",
  thumbnailUrl: "",
  prizes: [],
  campaignType: "most_likes",
  juryVotingType: "rank_voting",
  frequency: "once",
  severalTimesOptions: {
    numberOfInstances: "",
    closingDateOfFirstInstance: "",
  },
  votingStartWhen: "submissions_open",
  daysVotingAfterSubmissionsClose: "",
  daysUntilAnnounceWinners: "",
  juryMembers: [],
  messageToJuyMembers: "",
  experiencesParticipation: {
    privacy: "",
    // prizeContribution: "",
    // prizeMinimunValue: "",
    // prizeMinimunValueCurrency: "",
    // showResults: "",
  },
  experiences: [],
  platforms: [],
  status: "PUBLISH",
  isAcceptedEnwokeAgreement: false,
};

export default {
  name: "ContestForm",
  components: {
    ImageUploadButton,
    ExperiencePicker,
    PrizesControl,
    JuryControl,
    DateRangeControl,
    EnwokeDeclarationFieldset,
    AddContentButton,
    PlatformPicker,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      id: null,
      regions: [],
      districts: [],
      options: [
        { text: "Content with most 'Likes' wins", value: "most_likes" },
        { text: "Winner is determined by a jury", value: "select_by_jury" },
      ],
      options1: [
        { text: "Once", value: "once" },
        { text: "Several times", value: "several times" },
        { text: "Daily", value: "daily" },
        { text: "Weekly", value: "weekly" },
        { text: "Monthly", value: "monthly" },
      ],
      options2: [
        { text: "Mondays", value: "monday" },
        { text: "Tuesdays", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursdays", value: "thursday" },
        { text: "Fridays", value: "friday" },
        { text: "Saturdays", value: "saturday" },
        { text: "Sundays", value: "sunday" },
      ],
      formData: _.merge({}, defaultFormData),
    };
  },
  validations: {
    formData: {
      title: {
        required,
      },
      description: {
        required,
      },
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    prepare(content) {
      const formData = _.merge(defaultFormData, content); // Create a copy.
      const m = moment(formData.announcementDate);
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }

      if (formData.announcementDate != "") {
        formData.announcementDate = m.format("YYYY-MM-DD");
      }

      this.formData = formData;
      this.validateLocation(); // Re-validate to show country/region/district select box.
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    onSaveAndPublish(ev) {
      this.save("PUBLISH");
    },
    onSaveDraft() {
      this.save("DRAFT");
    },
    onUnpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH") {
      if (status === "PUBLISH" && !this.formData.isAcceptedEnwokeAgreement)
        return;

      if (!this.formData.title || this.formData.title.trim() === "") {
        this.formData.title = "Untitled";
      }

      this.formData.status = status;

      const urls = await this.$refs.urls.uploadImages();
      urls.forEach((url, index) => {
        this.formData.prizes[index].images = [url];
      });

      this.formData.prizes.forEach((item, index) => {
        this.formData.prizes[index].value = parseFloat(item.value);
      });

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      const date = this.$refs.date.value + " " + this.$refs.time.value;
      let dateString = "";
      if (date) {
        const m = moment(date);
        dateString = m.toJSON();
        this.formData.severalTimesOptions.closingDateOfFirstInstance = dateString;
      }

      if (this.formData.severalTimesOptions) {
        this.formData.severalTimesOptions.numberOfInstances = parseInt(
          this.formData.severalTimesOptions.numberOfInstances
        );
      }
      this.formData.daysVotingAfterSubmissionsClose = parseInt(
        this.formData.daysVotingAfterSubmissionsClose
      );
      this.formData.daysUntilAnnounceWinners = parseInt(
        this.formData.daysUntilAnnounceWinners
      );

      let promise = null;
      let saveData = _.merge({}, this.formData); // Clone data for saving.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);
      }

      const dateAnnoun = new Date(this.formData.announcementDate);
      saveData.announcementDate = dateAnnoun.toJSON();
      // Finalize save data.
      // if (saveData.prizes && saveData.prizes.length > 0) {
      //   saveData.prizes.forEach(prizes => {
      //     if (prizes.items && prizes.items.length > 0) {
      //       prizes.items = prizes.items.map(it => ({
      //         title: "", // Placeholder for now
      //         sponsor: "", // Placeholder for now
      //         description: it.id,
      //         value: it.id,
      //         images: it.id,
      //       }));
      //     }
      //   });
      // }

      this.$v.$touch();
      if (!this.$v.$invalid || status != "PUBLISH") {
        if (this.formData.id) {
          promise = this.$repo.contest.updateContest(saveData);
        } else {
          promise = this.$repo.contest.createContest(saveData);
        }

        promise
          .then((experience) => {
            this.$toasted.show("Save data successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right",
            });
            this.closeForm();
          })
          .catch((err) => {
            console.error(err);
            this.$toasted.show("Something went wrong.", {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          });
      }
    },
    async onDelete() {
      if (this.formData.id) {
        await this.$repo.contest.deleteContest(this.formData.id);
        this.closeForm();
      }
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    onCountryChanged() {
      this.regions = [];
      this.districts = [];
      this.formData.region = null;
      this.formData.district = null;

      const countryId = this.formData.country;
      if (!countryId) return;

      const country = this.$store.state.ref.locations.find(
        (it) => it.id === countryId
      );
      if (country && country.children && country.children.length > 0) {
        this.regions = country.children;
        this.formData.region = this.regions[0].id; // Auto focus first item.
      }
    },
    onRegionChanged() {
      this.districts = [];
      this.formData.district = null;

      const regionId = this.formData.region;
      if (!regionId) return;

      const region = this.regions.find((it) => it.id === regionId);
      if (region && region.children && region.children.length > 0) {
        this.districts = region.children;
        //this.formData.district = this.districts[0].id; // Auto focus first item.
      }
    },
    validateLocation() {},
  },
};
</script>

<style lang="scss">
$main-color: #c32aa3;

#contest-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }

  .form-check-label {
    font-size: 14px;
  }

  .form-control {
    border-radius: 0;
  }

  .underline {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
